import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/ROYALTIES.png'
import _imports_1 from '../../assets/registernewwork.svg'
import _imports_2 from '../../assets/works-approved.svg'
import _imports_3 from '../../assets/catalog-registered.svg'
import _imports_4 from '../../assets/syncopportunity.svg'
import _imports_5 from '../../assets/viewamendworks.svg'


const _hoisted_1 = { "data-testid": "publishing-overview" }
const _hoisted_2 = {
  key: 1,
  class: "panels-wrapper"
}
const _hoisted_3 = { class: "register-work-panel panel bg-blue text-white row items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-7-medium text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "left-image",
    src: _imports_0,
    alt: "work-image"
  })
], -1)
const _hoisted_5 = { class: "col-12 col-5-medium text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "work-icon",
  class: "is-hidden-below-medium"
}, null, -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "info-panel-wrapper" }
const _hoisted_9 = { class: "info-panel" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "icon-round" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "info-icon"
  })
], -1)
const _hoisted_11 = { class: "info-wrapper" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "info-panel" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "icon-round" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "info-icon"
  })
], -1)
const _hoisted_16 = { class: "info-wrapper" }
const _hoisted_17 = { class: "title text-body-light" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "sub-value" }
const _hoisted_20 = {
  class: "panel nav-panel elevate bg-lighter-grey text-blue text-center",
  "data-testid": "sync-ops"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "fill-body-light",
  alt: "tv opportunities icon"
}, null, -1)
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "is-hidden-below-small text-body-light" }
const _hoisted_24 = {
  class: "panel nav-panel elevate bg-lighter-grey text-blue text-center",
  "data-testid": "view-works"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "fill-body-light",
  alt: "edit work icon"
}, null, -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "is-hidden-below-small text-body-light" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import BlogsBlock from '@/components/Overview/BlogsBlock.vue'
import { useWorksStore } from '@/store/works'
import { useTracksStore } from '@/store/tracks'
import { useUserStore } from '@/store/user'
import { onMounted, ref } from 'vue'
import { useGettext } from 'vue3-gettext'
import IconUIVue from '@/components/CommonUI/IconUI.vue'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import NavBar from '@/components/NavBar.vue'
import UpgradeDialog from '@/components/UpgradeDialog.vue'
import { getErrorMessage } from '@/helpers/errors'


export default /*#__PURE__*/_defineComponent({
  __name: 'PublishingOverview',
  setup(__props) {

const { $gettext } = useGettext()

const upgradeDialog = ref<InstanceType<typeof UpgradeDialog> | null>(null)
const isLoaded = ref(false)
const errorMessage = ref('')
const worksStore = useWorksStore()
const trackStore = useTracksStore()
const userStore = useUserStore()
const syncOpsTitle = ref($gettext('<span class="light-text">Apply for the latest</span> Sync Opportunities'))
const worksTitle = ref($gettext('<span class="light-text">View/amend</span> Your Works'))
const workRegisterTitle = ref($gettext('<span class="light-text">Register a new</span> Musical Work.'))

const hasProOrLabelSubscription = userStore.hasProOrLabelSubscription

onMounted(async () => {
  if (!hasProOrLabelSubscription) {
    isLoaded.value = true
    upgradeDialog?.value?.show()
  } else {
    try {
      await Promise.all([
        worksStore.getUserAcceptedWorksCount(),
        worksStore.getWorksCount(),
        trackStore.getTracksCount(),
      ])

      isLoaded.value = true
    } catch (error) {
      errorMessage.value = getErrorMessage(error)
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar, { "is-mobile": "" }),
    _createVNode(UpgradeDialog, {
      ref_key: "upgradeDialog",
      ref: upgradeDialog
    }, null, 512),
    _createElementVNode("section", {
      class: _normalizeClass(["publishing-overview pad-0", { blurred: !_unref(hasProOrLabelSubscription) }]),
      "data-testid": "publishing-page"
    }, [
      _withDirectives((_openBlock(), _createElementBlock("h1", null, [
        _createTextVNode(" Publishing ")
      ])), [
        [_directive_translate]
      ]),
      _createElementVNode("section", _hoisted_1, [
        (!isLoaded.value)
          ? (_openBlock(), _createBlock(LoaderErrorBlock, {
              key: 0,
              "error-message": errorMessage.value,
              class: "row no-space justify-center"
            }, null, 8, ["error-message"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("h4", { innerHTML: workRegisterTitle.value }, null, 8, _hoisted_7),
                  _createElementVNode("p", null, _toDisplayString(_unref($gettext)('Add & register tracks from your release library to claim publishing royalties.')), 1),
                  _createVNode(_component_router_link, {
                    class: "button",
                    to: { name: 'MyWorks' }
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode("Register Song")
                      ])), [
                        [_directive_translate]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createTextVNode(" Works Approved: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(worksStore).acceptedWorksCount), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createTextVNode(" Catalog Registered: ")
                    ])), [
                      [_directive_translate]
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString(_unref(worksStore).worksCount), 1),
                      _createElementVNode("span", _hoisted_19, "/" + _toDisplayString(_unref(trackStore).tracksCount), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("h4", { innerHTML: syncOpsTitle.value }, null, 8, _hoisted_22),
                _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_23, [
                  _createTextVNode(" Submit your tracks for the chance to be featured in movies, TV shows, ads, games and more. ")
                ])), [
                  [_directive_translate]
                ]),
                _createVNode(_component_router_link, {
                  class: "button is-hidden-below-small",
                  to: { name: 'SyncOpportunities' }
                }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createElementBlock("span", null, [
                      _createTextVNode("Apply Now")
                    ])), [
                      [_directive_translate]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "button button-round button-small is-hidden-above-small",
                  to: { name: 'SyncOpportunities' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(IconUIVue, { name: "angle-right" })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("h4", { innerHTML: worksTitle.value }, null, 8, _hoisted_26),
                _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_27, [
                  _createTextVNode(" See the works you've already registered and the details that have been submitted. ")
                ])), [
                  [_directive_translate]
                ]),
                _createVNode(_component_router_link, {
                  class: "button is-hidden-below-small",
                  to: { name: 'MyWorks' }
                }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createElementBlock("span", null, [
                      _createTextVNode("My Works")
                    ])), [
                      [_directive_translate]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "button button-round button-small is-hidden-above-small",
                  to: { name: 'MyWorks' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(IconUIVue, { name: "angle-right" })
                  ]),
                  _: 1
                })
              ])
            ]))
      ]),
      _createElementVNode("section", null, [
        _hoisted_28,
        _createVNode(BlogsBlock)
      ])
    ], 2)
  ], 64))
}
}

})